// Copyright (c) 2019 by Michael Marucheck
//
// Use of this source code is governed by an MIT-style license that
// can be found in the LICENSE file distributed with this file.

import React from "react";
import { Link } from "react-router-dom";

function inter<T>(sep: T, array: T[]): T[] {
  return array.reduce(
    (acc: T[], x) => (acc.length === 0 ? [x] : [...acc, sep, x]),
    []
  );
}

export function navLink(to: string, text: string): NavBarLink {
  return { to, text };
}

function toLink(link: NavBarLink): React.ReactNode {
  return (
    <Link key={link.to} to={link.to}>
      {link.text}
    </Link>
  );
}

interface NavBarLink {
  text: string;
  to: string;
}

interface NavBarProps {
  caption?: string;
  wide: boolean;
  links: NavBarLink[];
}

export const NavBar: React.FC<NavBarProps> = props => {
  const { caption, links, wide } = props;
  return wide ? (
    <div key="NavBar_wide" className="nav">
      {caption} {inter(" | ", links.map(toLink))}
    </div>
  ) : (
      <div key="NavBar_narrow">
        {caption != null && (<div key="NavBar_caption">{caption}</div>)}
        {links.map(x => (
          <div key={x.to} className="nav">
            {toLink(x)}
          </div>
        ))}
      </div>
    );
};
